import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

export class DataDefinitionsClient extends BaseClient {
  buildEndpoint({projectId, workspaceId}: {projectId: number; workspaceId: number}) {
    return appApiUrl(`data-definitions`, {projectId, workspaceId});
  }

  processResponse(response: any, _params: any) {
    return response.results;
  }
}
